import React from 'react';
import { Image } from '../Image';
import { HighlightedBox } from '../HighlightedBox';

import Icon from '../../img/icon-phone.inline.svg';

export const RegisterContactInfo = {

  // Internal id of the component
  id: 'contactInfo',

  // Visible label
  label: 'Kontaktinfo',

  // Fields the user need to fill out when adding an instance of the component
  fields: [],

  // Pattern to identify a block as being an instance of this component
  // pattern: /^rentBuggy (\S+)$/,
  pattern: /<ContactInfo \/>/,

  // Function to extract data elements from the regexp match
  fromBlock(match) {
    return {
    };
  },

  // Function to create a text block from an instance of this component
  toBlock() {
    return '<ContactInfo />';
  },

  // Preview output for this component. Can either be a string or a React component
  // (component gives better render performance)
  toPreview() {
    return (
      <ContactInfo isPreviewMode />
    );
  },

};

// eslint-disable-next-line
export const ContactInfo = ({ isPreviewMode }) => (
  <HighlightedBox
    heading="Kontakt os"
    content={[ 'Vi står klar til at hjælpe dig.', 'golf@sollerodgolf.dk', '+45 45 80 17 84' ]}
    image={isPreviewMode ? <Image src={Icon} /> : <Icon />}
  />
);
